import { render, staticRenderFns } from "./DetailTable.vue?vue&type=template&id=7f07145c&scoped=true"
import script from "./DetailTable.vue?vue&type=script&lang=js"
export * from "./DetailTable.vue?vue&type=script&lang=js"
import style0 from "./DetailTable.vue?vue&type=style&index=0&id=7f07145c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f07145c",
  null
  
)

export default component.exports